export const GET_QUERIES = 'GET_QUERIES';
export const SET_QUERIES_LOADING = 'SET_QUERIES_LOADING';
export const CREATE_NEW_QUERY = 'CREATE_NEW_QUERY';
export const DELETE_QUERY = 'DELETE_QUERY';
export const DELETE_QUERY_ERROR = 'DELETE_QUERY_ERROR';
export const CREATE_NEW_MESSAGE = 'CREATE_NEW_MESSAGE';
export const UPDATE_QUERIES = 'UPDATE_QUERIES';
export const UPDATE_QUERY_TYPE = 'UPDATE_QUERY_TYPE';
export const CLEAR_QUERIES = 'CLEAR_QUERIES';
export const GET_AI_RESPONSE = 'GET_AI_RESPONSE';
export const UPDATE_AI_RESPONSE = 'UPDATE_AI_RESPONSE';
export const CLEAN_QUERIES_REDUCER = 'CLEAN_QUERIES_REDUCER';
export const GET_MESSAGES = 'GET_MESSAGES';
